
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { AlertTriangle } from 'lucide-react';

interface UrgencyChartProps {
  data: Array<{
    name: string;
    value: number;
    color: string;
  }>;
}

const UrgencyChart = ({ data }: UrgencyChartProps) => {
  const hasData = data.some(item => item.value > 0);

  if (!hasData) {
    return (
      <Card className="card-lift border-2 border-slate-200">
        <CardHeader>
          <CardTitle className="text-lg font-display font-bold flex items-center gap-2 text-amber-600">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
            Urgência dos Tickets
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-64 text-slate-500">
            <p className="font-medium">Nenhum ticket encontrado</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="card-lift border-2 border-slate-200 group relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-amber-600/5 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
      <CardHeader className="relative">
        <CardTitle className="text-lg font-display font-bold flex items-center gap-2 text-amber-600">
          <div className="p-2 bg-amber-100 rounded-lg">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          </div>
          Urgência dos Tickets
        </CardTitle>
      </CardHeader>
      <CardContent className="relative">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: '#64748b', fontWeight: 600 }}
              axisLine={{ stroke: '#cbd5e1' }}
            />
            <YAxis 
              tick={{ fill: '#64748b', fontWeight: 600 }}
              axisLine={{ stroke: '#cbd5e1' }}
            />
            <Tooltip 
              formatter={(value) => [value, 'Tickets']} 
              contentStyle={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.95)', 
                border: '2px solid #e2e8f0',
                borderRadius: '12px',
                padding: '12px',
                fontWeight: 600
              }}
            />
            <Bar 
              dataKey="value" 
              radius={[8, 8, 0, 0]}
              barSize={50}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default UrgencyChart;
